<div class="footer">
  <ng-container *ngIf="options.buttons?.left as leftButton">
    <button
      *ngIf="leftButton.visible()"
      tuiButton
      class="footer__button"
      type="button"
      appearance="primary"
      size="m"
      [iconStart]="leftButton.icon"
      [title]="leftButton.label"
      (click)="leftButton.action()"
    >
      {{ leftButton.label }}
    </button>
  </ng-container>

  <ng-container *ngIf="options.buttons?.right as rightButton">
    <button
      *ngIf="rightButton.visible()"
      tuiButton
      class="footer__button"
      type="button"
      appearance="secondary"
      size="m"
      [iconStart]="rightButton.icon"
      [title]="rightButton.label"
      (click)="rightButton.action()"
    >
      {{ rightButton.label }}
    </button>
  </ng-container>
</div>
